

































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import SaveCarrierRequest from '@/models/requests/SaveCarrierRequest';
import { CarrierLookup } from '@/models/carriers/CarrierLookup';

import carrierService from '@/services/CarrierService';
import localStorageService from '@/services/LocalStorageService';
import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editing: false,
      showFilters: false,
      displayEditCarrierPopup: false,
      displayAddCarrierPopup: false,
      snackbar: false,
      showPaging: false,
      snackbarText: '',
      displayConfirmDelete: false,
      deleting: false,
      currentCarrierId: null,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      carrierService
        .search({ active: true, inactive: true } as any)
        .then((x: CarrierLookup[]) => {
          const items = x.filter((p) => p.name?.trim().length > 0);

          let filters = new SaveCarrierRequest();
          const preSavedFilters = localStorageService.get(
            'admin-carriers-filter'
          ) as SaveCarrierRequest;
          if (preSavedFilters) {
            filters = preSavedFilters;
          }

          this.$store.commit('carriers/setCarriers', items);
          this.$store.commit('carriers/setFilter', filters);

          this.applyFilters();
          this.loading = false;
        });
    },
    applyFilters() {
      let items = this.all;

      // save filters to local storage
      localStorageService.set('admin-carriers-filter', this.searchFilter);

      if (this.searchFilter.name) {
        items = items.filter((x) =>
          x.name.toLowerCase().includes(this.searchFilter.name.toLowerCase())
        );
      }

      if (this.searchFilter.scac) {
        items = items.filter((x) =>
          x.scac?.toLowerCase().includes(this.searchFilter.scac.toLowerCase())
        );
      }

      if (this.searchFilter.city) {
        items = items.filter((x) =>
          x.city?.toLowerCase().includes(this.searchFilter.city.toLowerCase())
        );
      }

      if (this.searchFilter.state) {
        items = items.filter((x) =>
          x.state?.toLowerCase().includes(this.searchFilter.state.toLowerCase())
        );
      }

      if (this.searchFilter.country) {
        items = items.filter((x) =>
          x.country
            ?.toLowerCase()
            .includes(this.searchFilter.country.toLowerCase())
        );
      }

      if (this.searchFilter.mode) {
        items = items.filter((x) =>
          x.mode?.toLowerCase().includes(this.searchFilter.mode.toLowerCase())
        );
      }

      if (!this.searchFilter.active || !this.searchFilter.inactive) {
        items = items.filter(
          (x) =>
            (this.searchFilter.active && x.status) ||
            (this.searchFilter.inactive && !x.status)
        );
      }

      this.$store.commit('carriers/setFilteredCarriers', items);

      const page = items.slice(0, this.pageSize);
      this.$store.commit('carriers/setPage', page);
    },
    statusChanged(item) {
      carrierService.changeStatus(item.carrierId, item.status).then(() => {
        this.snackbarText = 'Carrier status changed.';
        this.snackbar = true;
      });
    },
    showHideFilters() {
      this.showFilters = !this.showFilters;
    },
    showEditDialog(carrier) {
      this.$store.commit('carriers/setCarrierToEdit', carrier);
      this.displayEditCarrierPopup = true;
    },
    resetFilter() {
      this.$store.commit('carriers/resetFilter');
      this.applyFilters();
    },
    pageChange(newPage) {
      let page = this.filteredCarriers.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('carriers/setPage', page);
    },
    confirmDelete(id) {
      this.displayConfirmDelete = true;
      this.currentCarrierId = id;
    },
    softDeleteCarrier() {
      this.deleting = true;
      carrierService.changeStatus(this.currentCarrierId, false).then(() => {
        this.deleting = false;
        this.displayConfirmDelete = false;
        this.snackbarText = 'Carrier deleted.';
        this.snackbar = true;
        this.fetch();
      });
    },
    onAddCarrierPopupClose() {
      this.$store.commit('carriers/setCarrierToEdit');
    },
    viewContacts(carrier) {
      localStorageService.set('selected-admin-carrier', carrier);
      miscService.goToPage(`/admin/carriers/${carrier.carrierId}/contacts`);
    },
    viewContracts(carrier) {
      localStorageService.set('selected-admin-carrier', carrier);
      miscService.goToPage(`/admin/carriers/${carrier.carrierId}/contracts`);
    },
    viewClients(carrier) {
      localStorageService.set('selected-admin-carrier', carrier);
      miscService.goToPage(`/admin/carriers/${carrier.carrierId}/clients`);
    },
    viewEquipmentTypes(carrier) {
      localStorageService.set('selected-admin-carrier', carrier);
      miscService.goToPage(`/admin/carriers/${carrier.carrierId}/equipment`);
    },
    viewDashboard(carrier) {
      localStorageService.set('selected-admin-carrier', carrier);
      miscService.goToPage(`/admin/carriers/${carrier.carrierId}/dashboard`);
    },
    carrierSaved() {
      this.snackbarText = 'Client Profile saved.';
      this.snackbar = true;

      this.resetFilter();
    },
    openNewCarrierPopup() {
      this.$store.commit('carriers/setCarrierToEdit');
      this.displayAddCarrierPopup = true;
    },
  },
  computed: {
    ...mapGetters('carriers', [
      'all',
      'page',
      'filteredCarriers',
      'searchFilter',
    ]),
    pagingLength() {
      return Math.ceil(this.filteredCarriers.length / this.pageSize);
    },
    filtersWidth() {
      if (this.lg || this.xl) return '60%';

      if (this.md) return '75%';

      return '90%';
    },
  },
});
